import React, { useEffect } from 'react'
import { BConnector } from '../../types/stations.types';
import MicroModalSelectorSearch, { CustomViewPickerRender } from '../../../../common/components/organisme/MicroModalSelectorSearch/MicroModalSelectorSearch';
import { Filter } from '../../../../utils/genericAPI/useGenericAPI';
import useQuerySelector from '../../../../common/hooks/useQuerySelector';
import { ResponseAPIWithPagination } from '../../../../utils/genericAPI/API.types';
import { connectorAPI } from '../../services/stationsAPI';


export interface ConnectorPickerProps {
    currentConnector?: BConnector;
    setCurrentConnector: (connector: BConnector | undefined) => void;
    isError?: boolean;
    style?: React.CSSProperties;
    customViewRender?: CustomViewPickerRender;
    label?: string;
    placeholder?: string;
    preFilter?: Filter<BConnector>;
}

export default function ConnectorPicker({
  currentConnector,
  setCurrentConnector,
  isError,
  placeholder = "Sélectionner un connecteur",
  preFilter,
  ...otherProps
}: ConnectorPickerProps) {



  
  const { resultFound, isLoading, setValueQuery, valueQuery, isLoadingMore, setPage, lastPage, page,sendQuery   } =
    useQuerySelector<ResponseAPIWithPagination<BConnector>>({
      getSearch: (query: string, page, pageSize) => {
        return connectorAPI.getAll({ search: query, page, pageSize, filter: preFilter , orderBy: "b_connector_tag_id" });
      },
      addMoreResult(prev, next) {
        return {
          ...next.data,
          data: [...prev.data, ...next.data],
        };
      },
      extractLastPage: (result) =>
        result.pagination.total_pages,
      pageSize: 4,
    });

  useEffect(() => {
    sendQuery("");
  }, [preFilter]);// eslint-disable-line

  return (
    <MicroModalSelectorSearch
    {...otherProps}
      valueSelectedName={currentConnector?.b_connector_tag_id ? String(currentConnector?.b_connector_tag_id): undefined}
      placeholder={placeholder}
      valueQuery={valueQuery}
      setQuery={setValueQuery}
      result={
        resultFound?.data
          ? resultFound?.data?.map((item: BConnector) => ({
              id: item.b_connector_id,
              name: String(item.b_connector_tag_id),
              item,
            }))
          : []
      }
      onClickItem={(item) => {
        setCurrentConnector(item.item);
      }}
      isLoading={isLoading}
      isError={isError}
      iconType="electric-car-plug"
      isLoadingMore={isLoadingMore}
      setPage={setPage}
      lastPage={lastPage || undefined}
      currentPage={page}
    />
  );
}
